<template>
  <div class="auth-wrapper auth-v1 px-2">
    <div class="auth-inner py-2">
      <!-- Reset Password v1 -->
      <b-card class="mb-0">

        <!-- Brand logo-->
        <b-link class="brand-logo">

          <img :src="logo_fondo_claro" alt="Logo" />

        </b-link>
        <!-- /Brand logo-->
        <b-card-title class="mb-1 text-nowrap">
          {{ $t('Restablecer la contraseña') }} 🔒
        </b-card-title>
        <b-card-text class="mb-2 text-center">
          {{ $t('Su nueva contraseña debe ser diferente de las contraseñas utilizadas anteriormente') }}
        </b-card-text>

        <!-- form -->
        <b-form @submit.prevent="cambiar" ref="refValidate" class="auth-reset-password-form mt-2">

          <!-- email -->

          <floating-input name="email" v-model="email" v-bind="emailProps" :state="!errors.email" :errors="errors"
            :label="$t('Email')">

          </floating-input>


          <!-- password -->
          <b-form-group :label="$t('Nueva contraseña')" label-for="reset-password-new">

            <b-input-group class="input-group-merge" >
              <b-form-input id="reset-password-new" v-model="password" v-bind="passwordProps" :type="passwordFieldType"
                :state="!errors.password" class="form-control-merge" name="reset-password-new"
                placeholder="············" />

              <b-input-group-text>
                <font-awesome-icon :icon="['fas', passwordToggleicon]" size="lg" class="cursor-pointer"
                  @click="togglePasswordVisibility" />
              </b-input-group-text>
            </b-input-group>

            <small class="text-danger">{{ errors.password }}</small>
          </b-form-group>

          <!-- confirm password -->
          <b-form-group label-for="reset-password-confirm" :label="$t('Confirmar Contraseña')">

            <b-input-group class="input-group-merge" >
              <b-form-input id="reset-password-confirm" v-bind="password_confirmationProps"
                v-model="password_confirmation" :type="passwordFieldType" class="form-control-merge"
                :state="!errors.password_confirmation" name="reset-password-confirm" placeholder="············" />

              <b-input-group-text>
                <section class="form-group-text">
                  <font-awesome-icon :icon="['fas', passwordToggleicon]" size="lg" class="cursor-pointer "
                    @click="togglePasswordVisibility" />
                </section>

              </b-input-group-text>

            </b-input-group>
            <small class="text-danger">{{ errors.password_confirmation }}</small>


          </b-form-group>

          <!-- submit button -->
          <b-button block type="submit" variant="primary" class="text-nowrap mt-1">
            {{ $t('Establecer nueva contraseña') }}
          </b-button>
        </b-form>



        <p class="text-center mt-2">
          <b-link :to="{ name: 'login' }">
            <font-awesome-icon icon="chevron-left" size="lg" />
            {{ $t('Volver al login') }}
          </b-link>
        </p>

      </b-card>
      <!-- /Reset Password v1 -->
    </div>
  </div>
</template>

<script setup>




// validatte
import { useForm } from 'vee-validate';
import { required,email as emailV,confirmed,password as passwordV } from '@validations'

import logotipo1 from 'images/logos/logotipo.png'
import logotipoblanco from 'images/logos/logotipo.png'
import router from '@/router';
import logo_fondo_claro from '@images/logos/logo_fondo_claro.svg';

import useTogglePassword from '@utils/useTogglePassword';

// i18n
import { useI18n } from 'vue-i18n';
const i18n = useI18n();
// storage
import useAppConfigStore from '@/store/app-config';

const app_config = useAppConfigStore();

const props = defineProps({
  token: {
    type: [String],
    required: true,
  }
})

const {token} = toRefs(props)

const { layout } = toRefs(app_config);
const skin = computed(() => layout.value.skin)

const formulario = ref({
  email:'',
  password:'',
  password_confirmation:'',
  token:computed(() => token.value)
})

const refValidate = ref(null)

const {defineField,errors,handleSubmit,resetForm,setErrors} = useForm({
  initialValues:formulario.value,
  validationSchema:{
    email:[emailV,required],
    password: [required, passwordV],
    password_confirmation: [required, (val, ctx) => confirmed(val, ctx.form.password, ctx)]
  }
});

const [email,emailProps] = defineField('email');
const [password, passwordProps] = defineField('password');
const [password_confirmation, password_confirmationProps] = defineField('password_confirmation');

const {
  passwordFieldType,
  togglePasswordVisibility,
  passwordToggleicon
} = useTogglePassword();


const cambiar = handleSubmit( (values) => {


  axios.post('/api/auth/reset-password',values).then(({data}) => {
    if (data.result) {
      toast.success(i18n.t('La contraseña se ha reestablecido exitosamente'));
      resetForm();
      router.push('/login');
    } else {
      toast.info((data.status == 'passwords.token') ? i18n.t('EL token ya no es valido, vuelve a enviar el link de reestablecimiento') : data.status)

      if (respon.data.status == 'passwords.token') {
        router.push({ name: 'auth-forgot-password' });
      }
    }


  }).catch(e => {
    console.log(e)
    if(e.response.status === 422){
      setErrors(e.response.data.errors)
    }

  })
});

const logotipo = computed(() => skin.value === 'dark' ? logotipoblanco : logotipo1)

</script>

<style lang="scss" scoped>
@import '@/assets/scss/vue/pages/page-auth.scss';

.auth-wrapper.auth-v1{
  .auth-inner{
    max-width: 400px !important;
  }
}
</style>